import React from 'react';
import { Text, StyleSheet, View } from 'react-native';
import { COLOR, FONT, THEME, __WEB__ } from '../../../constants/styles';
import OPComponent from '../op_component';
import TextUtils from '../../../textUtils';
import I18n from '../../../I18n';

export default class FieldTipText extends OPComponent {
  render() {
    const {
      tipText,
      requiredErrorText,
      invalidText,
      label,
      requiredError,
      validateError,
      containerStyle,
      readOnly,
    } = this.props;

    const flexibleHeight = !__WEB__ || this.props.flexibleHeight;
    const heightStyle = flexibleHeight ? {} : { height: 20 };

    let errorElem = null;
    const errorStyles = [styles.tipText, styles.errorText, containerStyle];
    if (requiredError) {
      let requiredText =
        requiredErrorText ||
        `${TextUtils.ce(label?.toLowerCase())} ${I18n.t('form.required')}${
          tipText ? `. ${tipText}` : ''
        }`;
      errorElem = <Text style={errorStyles}>{requiredText}</Text>;
    } else if (validateError) {
      errorElem = <Text style={errorStyles}>{invalidText || 'invalid value'}</Text>;
    } else if (!readOnly && tipText) {
      errorElem = <Text style={styles.tipText}>{tipText}</Text>;
    }

    return <View style={[styles.container, heightStyle]}>{errorElem}</View>;
  }
}

const styles = StyleSheet.create({
  container: {},
  tipText: {
    ...FONT.regular,
    fontSize: __WEB__ ? 16 : 14,
    color: COLOR.textLight,
  },
  errorText: {
    color: COLOR.error,
  },
});
